export default "__VITE_ASSET__CfsdfNt7__"